import css from './css-baseline.module.scss';

const CssBaseline = ({ children }) => {
	return <div className={css.root}>{children}</div>;
};

export default CssBaseline;
